import { DialogContent } from "@mui/material";
import "../../../assets/styles/modals.css";

export const ModalBody = (props: any) => {
  const { children, dividers = true } = props;

  return <DialogContent dividers={dividers}>{children}</DialogContent>;
};
